import { render, staticRenderFns } from "./LayoutCore.vue?vue&type=template&id=7a1c9e1b"
import script from "./LayoutCore.vue?vue&type=script&lang=js"
export * from "./LayoutCore.vue?vue&type=script&lang=js"
import style0 from "./LayoutCore.vue?vue&type=style&index=0&id=7a1c9e1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports